import * as Yup from 'yup';

export const CardHotListSchema = Yup.object().shape({
  reason: Yup.string().required('Select a reason for hotlisting'),
  serialNumber: Yup.string().required('Enter valid serial number'),
});
